<template>
    <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">
        <v-card>
            <v-card-title>
                <span class="headline">Christmas Calendar ({{ this.rules.name }})</span>
            </v-card-title>
            <v-card-text>
                <v-row dense class="mb-4">
                    <v-col cols="12" md="12" sm="12">
                        <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
                    </v-col>
                    <v-col cols="12" md="6" sm="6">
                        <v-text-field
                                label="Name"
                                v-model.trim="model.name"
                                v-ascii-only
                        />
                    </v-col>
                    <v-col cols="12" md="6" sm="6">
                        <v-text-field
                                label="Key"
                                v-model.trim="model.key"
                                v-ascii-only
                        />
                    </v-col>
                </v-row>
                <v-expansion-panels>
                    <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
                </v-expansion-panels>
                <v-row dense class="mt-4">
                    <v-expansion-panels>
                        <r-reward-track-panel :model.sync="model.track" title="Days Track"/>
                    </v-expansion-panels>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn @click="cancel" color="blue darken-1" text>
                    Cancel
                </v-btn>
                <v-btn @click="save" color="blue darken-1" text>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RRewardTrackPanel from "@/modules/redactor/views/reward/r-reward-track-panel.vue";
import {SmartOfferBundleChristmasCalendar} from "@/modules/redactor/models/smart-offer/bundle-christmas-calendar/SmartOfferBundleChristmasCalendar";

export default {
    name: "r-smart-offer-bundle-christmas-calendar",
    components: { RRewardTrackPanel, RGuardPanel},
    data: () => ({
        dialog: false,
        resolve: null,
        reject: null,
        tab: null,
        model: new SmartOfferBundleChristmasCalendar(),
        rules: ViewRules.READONLY,
    }),
    methods: {
        show(rules, model) {
            this.dialog = true;
            this.tab = null;
            this.rules = rules;
            this.model = model || new SmartOfferBundleChristmasCalendar();

            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        save() {
            if (this.model.valid()) {
                this.resolve(this.model);
                this.discard();
            } else {
                this.$alert("Invalid config!");
            }
        },
        cancel() {
            this.reject();
            this.discard();
        },
        discard() {
            this.dialog = false;
        },
        onenter() {
            this.save();
        }
    }
}
</script>
